import React, { useState } from 'react'
import Header from '../../Layout/Header'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons'

export default function Auctionpool() {

  const [isOpenpopup, setisOpenpopup] = useState(true)

  const Auction_Players = [
    {
      photo: '/assets/player/player1.svg',
      name: 'Maximus Dribbleto',
      player_id: '#785K91',
      token_price: '1899 Tokens',
      nature: 'right',
      soldout_time: '18h 23m'
    },
    {
      photo: '/assets/player/player2.svg',
      name: 'Leo Passini',
      player_id: '#456Y12',
      token_price: '1320 Tokens',
      nature: 'right',
      soldout_time: '32h 15m'
    },
    {
      photo: '/assets/player/player3.svg',
      name: 'Wen Yan',
      player_id: '#890P34',
      token_price: '1675 Tokens',
      nature: 'right',
      soldout_time: '25h 41m'
    }
  ]
  return (
    <div className='min-h-screen bg-cover text-white flex flex-col' style={{ backgroundImage: 'url("/assets/bg/Fundbg.svg")' }}>
      <div className='h-[90px]'><Header /></div>
      <div className='flex flex-1 items-center'>
        <div className='w-[90%] mx-auto pt-5 pb-5 2xl:pt-0 2xl:pb-5'>
          <h1 className='text-center font-bold text-xl lg:text-2xl 2xl:text-3xl uppercase'>Auction pool</h1>
          <div className='mt-7 border border-[#888888] rounded-md px-5 py-2 2xl:py-3 flex items-center gap-3'>
            <i className='fa-solid fa-magnifying-glass text-[#20FF5F]'></i>
            <input className='outline-none w-[100%] placeholder:font-bold' placeholder='Search for the club / player status'></input>
            <p className='text-[#20ff5f] uppercase font-semibold'>search</p>
          </div>
          <div className='flex items-ceneter mt-3'>
            <h1 className='text-[#ADB0BC]'>sort by: <span className='ml-3 text-white font-bold'>Familarity</span></h1>
          </div>
          <div className='relative'>
            <div className={`mt-5 ${Auction_Players.length > 0 ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10' : ''}`}>
              {Auction_Players.length > 0 ? (
                Auction_Players.map((item, index) => (
                  <div key={index} className='bg-white/10 relative p-5 space-y-3 grid content-around brand-fade-2 overflow-hidden'>
                    <div className='w-full py-1 font-bold text-center text-black bg-white absolute rotate-45 -right-[40%] top-[3%]'>
                      FWR
                    </div>
                    <div className='h-[225px] flex items-center justify-center'>
                      <img src={item.photo} className='object-cover h-full mx-auto'></img>
                    </div>
                    <div className='flex items-center justify-between' style={{ fontFamily: "Audiowide" }}>
                      <h1 className='uppercase text-wrap 2xl:text-base truncate'>{item.name}</h1>
                      <h2 className='uppercase text-wrap 2xl:text-base truncate'>{item.player_id}</h2>
                    </div>
                    <div className='flex justify-between text-xs font-medium 2xl:text-sm' style={{ fontFamily: "Sarpanch" }}>
                      <div>
                        <p className='text-[#757575]'>Current Bid</p>
                        <p>{item.token_price}</p>
                      </div>
                      <div>
                        <p className='text-[#757575]'>Nature</p>
                        <p className='capitalize'>{item.nature}</p>
                      </div>
                      <div>
                        <p className='text-[#757575]'>Ending in</p>
                        <p>{item.soldout_time}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className='h-[250px] text-xl font-bold'>
                  <p className='flex justify-center items-center '><FontAwesomeIcon icon={faMagnifyingGlass} className='mr-2 text-3xl' /> NO DATA</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isOpenpopup && (
        <div className="fixed inset-0 flex items-center h-full  md:justify-center bg-[#000]/70 z-100 px-2 py-5 overflow-auto fade-up-slide">
          <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative">
            <div className='block md:hidden'><FontAwesomeIcon icon={faXmark} onClick={() => { setisOpenpopup(false) }} className='absolute right-3 top-3' /></div>
            <div>
              <h1 className='text-[#fff] text-xl font-bold text-center uppercase'>The Transfer Tunnel Awaits!</h1>
              <div className='flex justify-center'>
                <img className='w-3/12' src='/assets/others/Gaol-popup2.svg'></img>
              </div>
              <p className='text-white text-center text-sm mt-4 uppercase'>Welcome to the GoalDex Marketplace – your ultimate transfer zone where clubs and players strike deals, scout talent, and make history <br/><br/>
                But hold your whistles! The Marketplace is warming up – Coming soon to steal the show!</p>
              <div className='flex justify-center mt-3'><button className='bg-[#D9D9D9]/40 rounded-full font-semibold px-10 py-2 cursor-pointer' onClick={() => { setisOpenpopup(false)}}>Let's Explore</button></div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}


